var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-gridcomponent",class:{
		'selected': !!_vm.grid.selected
	},style:({
		'width': _vm.width+'px',
		'height': _vm.height+'px',
		'left': 'calc(50% - '+(_vm.width/2)+'px)',
		'top': 'calc(50% - '+(_vm.height/2)+'px)',
		'transform': 'scale('+_vm.scale+') translate('+_vm.offsetX+'px, '+_vm.offsetY+'px)',
		'--grid-size': _vm.SIZE+'px',
	})},[_vm._l((_vm.grid.cells),function(cells){return [_vm._l((cells),function(cell){return [_c('cell-button',{attrs:{"cell":cell},on:{"on-before-confirm":function($event){return _vm.onBeforeConfirm()},"on-confirm":function($event){return _vm.onConfirm()}}})]})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }